export enum LabelTextClass {
  Normal = '',
  Defined = 'defined',
  Deviated = 'deviated',
}
